import { ProgramNodeDateMap, OnsiteActivity, OnsiteSchedule, OnsiteTimelineBrick, ProgramNode, OnsiteSingleTimeline } from '../../../globals/store/onsite.data';
import { DateSchedule, Program } from '../../../globals/store/programs.data';
import { getOnsiteSchedules } from './../../../globals/share/onsite.getoss';
import { filterTimeline } from '../../../globals/share/onsite.filtering';
import { Dictionary } from '@ngrx/entity';
import { populateTimelineData } from '../../../globals/functions/onsite.reselector.functions'
import { convertFullMultiTimelineToSingleTimeline, initializeFullMultiTimeline, sortProgramNodesList } from 'globals/functions/onsite.reselector.functions';
import { flatten, makeMapFromListOfObjectsAndKey, str2Date, typedValues } from 'globals/helpers/helpers';
import { Performer } from 'globals/store/performers.data';
import { Asset } from 'globals/store/assets.data';
import { Exhibitor, ExhibitorStand } from 'globals/store/exhibitors.data';
import { JoiResource } from 'globals/store/resources.data';
import { FilterGroup } from 'globals/store/filters.data';



export const initializeMultiTimeline = (programNodesByDate: ProgramNodeDateMap, dateId: string, performers: { [pId: string]: Performer }, eventProgramOrder: string[]): DateSchedule => {

	if (!dateId || !programNodesByDate || !programNodesByDate[dateId]) {
		return {id: dateId, date: new Date(), programs: []}
  }
  const multiTimeline = {id: dateId, date: str2Date(dateId), programs: []}
  populateTimelineData(programNodesByDate[dateId], multiTimeline, performers, eventProgramOrder)
  // console.log(dateId, { multiTimeline: jsonCopyObject(multiTimeline )})
	return multiTimeline
}

export interface BriefStatusBySessAndPerfId { [sId: string]: { [pId: string]: string }}

export const getSessionList = (programs: Dictionary<Program>) => flatten(typedValues(programs).map(p => typedValues(p.sessions_obj)))
export const getSessionMapFromPrograms = (programs: Dictionary<Program>) => makeMapFromListOfObjectsAndKey(getSessionList(programs), 'id')

export const getBriefStatusBySessionAndPerformerId = (performers: Dictionary<Performer>, programs: Dictionary<Program>) => {
  const briefStatusBySessionAndPerformerId:BriefStatusBySessAndPerfId = {}
  Object.values(programs).forEach(program => 
    Object.values(program.sessions_obj).filter(({ performerBriefStatus }) => performerBriefStatus).forEach(({ id, performerBriefStatus }) => {
      briefStatusBySessionAndPerformerId[id] = {}
      Object.entries(performerBriefStatus).filter(([pId, _]) => !!performers[pId]).forEach(([ performerId, status ]) => {
        briefStatusBySessionAndPerformerId[id][performerId] = status
      })
    }        
  ))
  return briefStatusBySessionAndPerformerId
}

export interface BriefTimelineInputs {
  activities: OnsiteActivity[]
  schedules: OnsiteSchedule[]
  programs: Program[]
  assets: { [aId: string]: Asset }
  performerId?: string
  performers: { [pId: string]: Performer }
  exhibitorId?: string
  exhibitors?: { [eId:string]: Exhibitor }
  resourceId?: string
  resources?: { [rId:string]: JoiResource}
  stands: { [sId:string]: ExhibitorStand }
  attendeeId?: string
  eventProgramOrder: string[]
}





export const getFullBriefTimeline = (inputs: BriefTimelineInputs): OnsiteSingleTimeline[] => {
  const { activities = [], schedules, programs, performerId = null, exhibitorId = null , exhibitors, performers, resources, stands, assets, resourceId, eventProgramOrder, attendeeId } = inputs
  
  const programMap = makeMapFromListOfObjectsAndKey(programs, 'id')
  // console.log('getFullBriefTimeline', { programs, programMap })
  
  if (!schedules || !programs || (!performerId && !exhibitorId && !resourceId && !attendeeId) || !assets) {
    console.log("SOMETHING MISSING!", { activities, schedules, programs, performerId, exhibitorId, resourceId, attendeeId, exhibitors, performers, stands, assets })
    return null
  }

  const { programNodesByDate } = getOnsiteSchedules(activities, schedules, programs, true)
  const allProgramNodes = flatten(Object.values(programNodesByDate).map(programNodesMap => Array.from(programNodesMap.values())))
  sortProgramNodesList(allProgramNodes, eventProgramOrder)
  const fullScheduleOrder = allProgramNodes.map(p => p.schedule.scheduleId)

  const multiTimelines = initializeFullMultiTimeline(programNodesByDate, performers, eventProgramOrder)
  // console.log({ programNodesByDate, performers, multiTimelines: jsonCopyObject(multiTimelines) })

  const filters: FilterGroup = { count: 1 }
  if (performerId) filters.performers = [performerId]
  if (exhibitorId) filters.exhibitors = [exhibitorId]
  if (resourceId) filters.resources = [resourceId]
  if (attendeeId) filters.attendees = [attendeeId]
  // console.log({ filters })

  const filteredMultiTimelines = filterTimeline(multiTimelines, filters, false, exhibitors, performerId ? 'performerBrief' : exhibitorId ? 'exhibitorBrief' : attendeeId ? 'attendeeBrief' : 'resourceBrief', stands, programMap)
  // console.log({ filteredMultiTimelines: jsonCopyObject(filteredMultiTimelines) })


  const timeline = convertFullMultiTimelineToSingleTimeline(filteredMultiTimelines, assets, fullScheduleOrder)
  // console.log({ timeline: jsonCopyObject(timeline)})

  return timeline
}